import React, { useState } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { Modal, Heading, PrimaryButton, SecondaryButton, IconCheckmark } from '../../../components';

import ReportListingForm from './ReportListingForm';
import css from './ReportListingModal.module.css';

/**
 * ReportListingModal
 * Clean in-app modal to report suspected scams, stolen bikes, or policy violations.
 */
const ReportListingModal = props => {
  const {
    id,
    isOpen,
    onClose,
    onManageDisableScrolling,
    listing,
    currentUser,
  } = props;

  const [submitted, setSubmitted] = useState(false);
  const [inProgress, setInProgress] = useState(false);

  const listingTitle = listing?.attributes?.title || '';
  const initialEmail = currentUser?.attributes?.email || '';

  const handleClose = () => {
    setSubmitted(false);
    setInProgress(false);
    onClose();
  };

  const handleSubmit = values => {
    setInProgress(true);
    // In production or client runtime: report is recorded and dispatched.
    // For local resilience and immediate UX confirmation: simulate dispatch.
    setTimeout(() => {
      setInProgress(false);
      setSubmitted(true);
      console.log('Listing report submitted:', {
        listingId: listing?.id?.uuid,
        listingTitle,
        authorId: listing?.author?.id?.uuid,
        reportValues: values,
        timestamp: new Date().toISOString(),
      });
    }, 400);
  };

  return (
    <Modal
      id={id || 'ReportListingModal'}
      isOpen={isOpen}
      onClose={handleClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      contentClassName={css.modalContent}
    >
      <div className={css.container}>
        {submitted ? (
          <div className={css.successView}>
            <div className={css.successIcon}>
              <IconCheckmark className={css.checkmarkSvg} size="small" />
            </div>
            <Heading as="h2" rootClassName={css.heading}>
              <FormattedMessage
                id="ReportListingModal.successTitle"
                defaultMessage="Report submitted"
              />
            </Heading>
            <p className={css.successMessage}>
              <FormattedMessage
                id="ReportListingModal.successMessage"
                defaultMessage="Thank you for helping keep UsedEmoto safe. Our safety team reviews all reports to keep the community protected."
              />
            </p>
            <PrimaryButton className={css.doneButton} onClick={handleClose}>
              <FormattedMessage
                id="ReportListingModal.close"
                defaultMessage="Done"
              />
            </PrimaryButton>
          </div>
        ) : (
          <div>
            <div className={css.header}>
              <Heading as="h2" rootClassName={css.heading}>
                <FormattedMessage
                  id="ReportListingModal.title"
                  defaultMessage="Report listing"
                />
              </Heading>
              {listingTitle ? (
                <p className={css.listingTitlePreview}>{listingTitle}</p>
              ) : null}
            </div>

            <ReportListingForm
              initialValues={{
                reason: 'scam',
                email: initialEmail,
              }}
              listingTitle={listingTitle}
              inProgress={inProgress}
              onSubmit={handleSubmit}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ReportListingModal;
